<template>
  <div class="border-bottom" v-if="project.visible !== 0">
    <div class="m-hint flex-between row row-align-center">
     <span @click.stop="projectClicked(project)" :class="{'col': !showStar, 'col-5': showStar }">
       <i class="icon " :class="checkedClass"></i>
       {{project.item}}
     </span>
      <div class="col row-align-center row" v-if="showStar && project.star">
        <span class="projectStar " :class="'star-' + project.star"></span>
      </div>
      <em @click.stop="iconClicked" class="col-auto"><span>{{projectPrice}}</span><i
          class="icon icon-arrow-right"
      ></i></em>

    </div>
    <!--<special-alert v-if="project.addWarning==='1' && project.warningInfo">{{project.warningInfo}}</special-alert>-->
    <special-alert v-if="project.addWarning==='1' && project.warningInfo">{{project.warningInfo}}</special-alert>
    <delete-recommend :showModal="showDeleteRecommend" :project="project" v-if="recommend"
                      @btnClose="closeDeleteRecommend"></delete-recommend>
    <hint :showModal="showHint" :showTxt="hintMsg.title" :btnList="hintMsg.btn" @btnClick="hanlder"></hint>
  </div>
</template>

<script>
import hint from '@/components/common/hint'
import specialAlert from '@/components/common/specialAlert'
import deleteRecommend from '@/components/common/deleteProject/deleteRecommend'
import { Toast } from 'vant'
import { mapState } from 'vuex'
import projectUtil from '@/assets/scripts/project'

export default {

  //    name: 'project',
  data () {
    return {
      showHint: false,
      hintMsg: {
        title: '',
        btn: ['取消', '选择此项目！']
      },
      code: false,
      hintMutex: true,
      showDeleteRecommend: false,
      showProjectModal: false
    }
  },
  props: {
    showStar: {
      type: Boolean,
      default: false
    },
    mutexId: {
      type: String,
      default: ''
    },
    recommend: {
      type: Boolean,
      default: false
    },
    checkedList: {
      type: Array,
      default: []
    },
    project: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'checkbox'
    }
  },
  methods: {
    hanlder (index) {
      if (index) {
        this.hintMutex = false
        this.projectClicked(this.project)
      }
      this.showHint = false
    },
    closeDeleteRecommend (index) {
      if (!index) {
        this.code = true
        this.projectClicked(this.project)
      }
      this.showDeleteRecommend = false
    },
    projectClicked (project) {
      if ((this.project.delectable !== '1' || this.isCheckedMaterialProject || this.isTransform) && this.isChecked) {
        Toast({
          type: 'fail',
          duration: 3000, // 持续展示toast 5s
          message: '该项目不可取消'
        })
        return
      }
      if ((!this.recommend || this.code) || !this.isChecked) {
        if (!this.isCheckedMaterialProject && !this.isTransform) {
          console.log(project.mutexId)
          if (project.mutexId && this.hintMutex && this.recommend) {
            let mutexIdList = project.mutexId.split(',')
            console.log(mutexIdList)
            let mutexsName = []
            mutexIdList.forEach(obj => {
              let mutexs = this.projectMutexList[obj]
              let checkedMaterialProjectList = this.$store.state.project && this.$store.state.project.checkedMaterialProjectList || []
              for (var id in mutexs) {
                (this.checkedList || []).forEach(p => {
                  (mutexs[project.id] === 1 || mutexs[p.id] === 1) && id === p.id && project.id !== p.id && !mutexsName.includes(p.item) && mutexsName.push(p.item)
                })
                checkedMaterialProjectList.forEach(p => {
                  (mutexs[project.id] === 1 || mutexs[p.id] === 1) && id === p.id && project.id !== p.id && !mutexsName.includes(p.item) && mutexsName.push(p.item)
                })
              }
            })

            if (mutexsName.length) {
              this.hintMsg.title = `${project.item}与已选项目（${mutexsName.join('、')})互斥，选择此项目，将自动取消${mutexsName.join('、')}`
              this.showHint = true
              return
            }
          }
          this.$store.commit('project/checkProject', project)
          this.$store.commit('project/setProductProjects')
          this.$store.commit('project/setProjectPricingRules')
          this.$store.commit('project/setCheckedMaterialProjectList')
          this.code = false
          this.hintMutex = true
        }
      } else if (this.isChecked) {
        this.showDeleteRecommend = true
      }
    },
    iconClicked () {
      this.$emit('iconClicked', this.project)
    }
  },
  computed: {
    ...mapState('project', {
      projectMutexList: state => state.projectMutexList,
      mTransformList: state => state.mTransformList,
      isDelList: state => state.isDelList,
      productProjects: state => state.productProjects
    }),
    isTransform:

        function () {
          let hasProject = false
          if (this.mTransformList && this.mTransformList.tree) {
            hasProject = this.mTransformList.tree.some(obj => { return obj.id === this.project.id })
          }
          return hasProject
        },

    isCheckedPackageProject: function () {
      let state = this.project.packable === 1
      if (this.project.hasOwnProperty('priceDifference') && this.project.priceDifference[this.mutexId] < 0) {
        state = true
      } else if (this.project.packable === 1 && this.project.mutexId) {
        for (let id of this.project.mutexId.split(',')) {
          if (this.checkedList.some((p) => `,${p.mutexId},`.includes(`,${id},`))) {
            state = false
            break
          }
        }
      }
      return state
    },

    isCheckedMaterialProject () {
      return (this.$store.state.project && this.$store.state.project.checkedMaterialProjectList || []).some(p => p.id === this.project.id)
    },

    projectPrice () {
      if (this.$store.state.project.showProjectPrice === '0') {
        return ''
      } else if (this.project.packable === 1) {
        return '套餐项目'
      } else if (this.mutexId && this.project.hasOwnProperty('priceDifference') && this.project.priceDifference[this.mutexId] >= 0) {
        return `补差价${this.project.priceDifference[this.mutexId]}`
      } else {
        return `${this.project.price}元`
      }
    },

    replacedList () {
      let list = true
      if (this.isDelList && this.isDelList.length) {
        list = !this.isDelList.some(p => this.project.id === p.id)
      }
      return list
    },

    isChecked () {
      let id = this.project.id
      let isChecked = this.project.packable === 1 ? this.replacedList : (this.checkedList.some(p => id === p.id) || this.isCheckedMaterialProject)
      return isChecked
    },

    checkedClass () {
      let isChecked = this.isChecked
      let classes = []
      if (isChecked || this.isTransform) {
        if (this.type !== 'radio') {
          classes.push('icon-newxuanzhongduoxuan')
        } else {
          if (this.mutexId && this.projectMutexList[this.mutexId] && this.projectMutexList[this.mutexId][this.project.id] === 0) {
            classes.push('icon-newxuanzhongduoxuan')
          } else {
            classes.push('icon-radiobox')
          }
        }
        if (this.project.delectable === '1' && !this.isCheckedMaterialProject && !this.isTransform) {
          classes.push('buletive')
        }
      } else {
        if (this.mutexId && this.projectMutexList[this.mutexId] && this.projectMutexList[this.mutexId][this.project.id] === 0) {
          classes.push('icon-duoxuankuang')
        } else {
          if (this.type !== 'radio') { classes.push('icon-duoxuankuang') } else { classes.push('icon-danxuankuang') }
        }
      }
      return classes.join(' ')
    }
  },
  name: 'projectSelect',
  components: {
    specialAlert,
    deleteRecommend,
    hint
  }
}
</script>

<style ref="stylesheet/scss" lang="scss" scoped>
  .m-child-box {
    .border-bottom {
      border-bottom: 1px solid #f5f5f5
    }
    .warning-info {
        font-size: 16px !important;
      margin: 0 15px 5px 15px;
    }
    .m-hint {
      line-height: 44px;
      padding-left: 15px;
      display: flex;
      .icon {
        position: relative;
        top: 2px;
        margin-right: 10px;
        font-size: 22px;
        color: #999999;
      }
      .icon-arrow-right {
        margin-right: 0;
        padding-left: 10px;
        padding-right: 8px;
        font-size: 14px;
        color: #999999;
      }
      > span {
        padding-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        color: #333;
      }
      em {
        padding-left: 15px;
        /*width: 110px;*/
        text-align: right;
        color: #999999;
      }
    }
  }
</style>
